module.exports = __webpack_public_path__ + "static/media/gs.c7e0feea.svg";